require('../../modules/es6.math.sign');
module.exports = require('../../modules/_core').Math.sign;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/math/sign.js
 ** module id = 862
 ** module chunks = 1
 **/